import { render, staticRenderFns } from "./CreateAppoint.vue?vue&type=template&id=f61c8c88&scoped=true&"
import script from "./CreateAppoint.vue?vue&type=script&lang=js&"
export * from "./CreateAppoint.vue?vue&type=script&lang=js&"
import style0 from "./CreateAppoint.vue?vue&type=style&index=0&id=f61c8c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61c8c88",
  null
  
)

export default component.exports